import { connect } from "react-redux";

import MinorQuestionnaire from "./MinorQuestionnaire";
import { withFirebase } from "../../../../data/index";
import registrationStep from "../../../registrationStep";

const withData = withFirebase(MinorQuestionnaire, ["questions/minor"]);
const withState = connect(state => ({
  questionnaire: "minor",
  questions: state.data.questions.minor
}))(withData);

export default registrationStep(
  withState,
  "minor-questionnaire",
  "minors/list"
);



// WEBPACK FOOTER //
// ./src/registration/components/Minors/MinorQuestionnaire/index.js